export const googleLink = 'https://www.google.com/maps/?daddr=';
